import React from 'react';

const Error404 = () => (
    <div>
        Page not found
    </div>
);

export default Error404;
